import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * PageTransition wrapper - adds smooth animations when navigating between pages
 */
const PageTransition = ({ children, className = '' }) => {
  const location = useLocation();
  
  return (
    <div 
      key={location.pathname}
      className={`page-transition ${className}`}
    >
      {children}
    </div>
  );
};

export default PageTransition;
